import React from 'react'
import DialogBox from '../../../../constants/DialogBox';
import { Grid } from '@mui/material';
import InputTextBox from '../../../../constants/InputTextBox';
import { useFormik } from 'formik';
import { postDataToTheServer } from '../../../../helpers/api';
import AppURL from '../../../../constants/AppURL';
import { ToastError, ToastSuccess, ToastWarning } from '../../../../constants/Toast';
import { BSToADUSFormat, NepNowDateFormat } from '../../../../constants/DateFormat';
import { EndBaseLine } from '../../../../constants/AppSpace';
import { Button } from '../../../../constants/Button';
interface EMIFormProps {
    emiOpen: {
        open: boolean;
        member_sn: number;
    };
    setOnEmi: (emiState: { open: boolean; member_sn: number }) => void;
}
const EMIFormView: React.FC<EMIFormProps> = ({ emiOpen, setOnEmi }) => {
    const nepDate = NepNowDateFormat();
    const initialValues = {
        date_en: nepDate?BSToADUSFormat(nepDate):"no",
        date_ne: nepDate || "",
        amt: "",
        paid_amt: "",
        total_month: "",
        paid: "",
        member_sn: emiOpen.member_sn || "",

    };
    const { values, errors, touched, setFieldValue, handleBlur, handleChange, handleSubmit } =
        useFormik({
            initialValues,
            enableReinitialize: true,
            onSubmit: async (values, action) => {
                const formData = new FormData();
                Object.keys(values).forEach((key) => {
                    const value = (values as Record<string, any>)[key];
                    if (value !== undefined && value !== null && value !== "") {
                        formData.append(key, value);
                    }
                });
                try {
                    await postDataToTheServer(AppURL.FrontOfficeURL + "front/customer/emi/create/list/view/", formData).then((res) => {
                        console.log(res)
                        if (res?.status === 201) {
                            ToastSuccess({ message: res?.message });
                            action.resetForm();
                            setOnEmi({ open: false, member_sn: emiOpen.member_sn })
                        } else if (res?.status === 400) {
                            ToastWarning({message: res?.message});
                        } else {
                            ToastError({ message: "Something Error " })
                        }
                    });
                } catch (error) {
                    console.log(error);
                }
            },
        });
    return (
        <DialogBox open={emiOpen.open} headerName='EMI Add' close={() => setOnEmi({ open: false, member_sn: emiOpen.member_sn })}>
            <form onSubmit={handleSubmit}>
                <Grid container columnSpacing={3} rowSpacing={0.8}>
                <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='member_sn'
                            label='Member SN'
                            disabled={true}
                            handleChange={handleChange}
                            value={values.member_sn?.toString()}
                            error={errors.member_sn?.toString()}
                            handleBlur={handleBlur}
                            touched={touched.member_sn ? true : false}
                            required={true}
                            placeholder='0'
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='date_ne'
                            label='Date'
                            disabled={true}
                            handleChange={handleChange}
                            value={values.date_ne}
                            error={errors.date_ne?.toString()}
                            handleBlur={handleBlur}
                            touched={touched.date_ne ? true : false}
                            required={true}
                            placeholder='XXXX/XX/XX'
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='number'
                            name='amt'
                            label='Paid Amt'
                            handleChange={handleChange}
                            value={values.amt}
                            error={errors.amt}
                            handleBlur={handleBlur}
                            touched={touched.amt}
                            required={true}
                            placeholder='Enter Amount'
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='total_month'
                            label='Total Month'
                            handleChange={handleChange}
                            value={values.total_month}
                            error={errors.total_month}
                            handleBlur={handleBlur}
                            touched={touched.total_month}
                            required={true}
                            placeholder='Enter total Month'
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <EndBaseLine top={18}>
                            <Button btn_type='save' type='submit' el='button' />
                        </EndBaseLine>
                    </Grid>
                </Grid>
            </form>
        </DialogBox>
    )
}

export default EMIFormView